import ColumnBars from './ColumnBars';

interface Bucket { bucket: string; count: number; }
interface Props {
  buckets: Bucket[];
  height?: number;
  /** Buckets starting below this mark are highlighted. Defaults to 50. */
  passPct?: number;
  /** Show the count above each bar (exam report). */
  showValues?: boolean;
}

/** Design CP histogram: 10-point buckets, a 4px minimum bar, tooltip "40–49%: 3 students". */
export default function HistogramChart({ buckets, height = 240, passPct = 50, showValues = false }: Props) {
  return (
    <ColumnBars
      height={height}
      minBar={4}
      showValues={showValues}
      label={`Students by average score: ${buckets.map((b) => { const lo = parseFloat(b.bucket); return Number.isFinite(lo) ? `${lo}–${lo + 9}%: ${b.count}` : `${b.bucket}: ${b.count}`; }).join(', ')}`}
      buckets={buckets.map((b) => {
        const lower = parseFloat(b.bucket);
        const ok = Number.isFinite(lower);
        return {
          label: ok ? String(lower) : b.bucket,
          value: b.count,
          highlight: ok && lower < passPct,
          title: ok ? `${lower}–${lower + 9}%: ${b.count} ${b.count === 1 ? 'student' : 'students'}` : undefined,
        };
      })}
    />
  );
}
